import { FC } from 'react';
import { FrostedGate } from '../../components/FrostedGate/FrostedGate';
import { FrostTarget } from '../../components/FrostedGate/frosted-gate.constants';
import { KpiModuleVariant } from './kpi-preview-screen';
import { KpiLoader } from './KpiLoader';
import { KpiModulePreview } from './KpiModulePreview';

const FROST_TARGET: Record<KpiModuleVariant, FrostTarget> = {
  consolidated: 'kpis',
  consolidatedV2: 'kpis',
  legacy: 'kpis.legacy',
  managedServices: 'kpis',
};

interface KpiModuleGateProps {
  variant: KpiModuleVariant;
}

/** Module boundary for KPIs: frosted, every KPI route shows a sample of its own screen and the loader never runs. */
export const KpiModuleGate: FC<KpiModuleGateProps> = ({ variant }) => (
  <FrostedGate target={FROST_TARGET[variant]} preview={<KpiModulePreview variant={variant} />}>
    <KpiLoader />
  </FrostedGate>
);
